import React from 'react';
import IdleTimer from 'react-idle-timer';
import { API_HEADERS, API_URL } from '../../../constants/api';
import { authenticationSilentParameters, authProvider } from '../../../authProvider';
import { apiRequestNoLoadder } from '../../../utils/api_service';
import { getLastFetchedSPSTokenData, setSPSToken } from '../../../constants/appConstants';
import moment from 'moment';
import { ShowToast, toastType } from '../../../utils/toast-service';
let callGetAfterCount = 0;
const IDLE_TIME = 45 * 60 * 1000;

export default function IdleSessionTimer() {
  function handleOnAction(event) {
    // const options = event?.target?.getAttribute('role')?.value;
    let reload = true;
    // console.log(' event.target', event?.target);
    // console.log(' event.target.className', event?.target?.className);
    if (event?.target?.className?.length > 0 && event?.target?.className.indexOf('MuiAutocomplete') >= 0) {
      reload = false;
    }

    // if (event.type === 'mousedown' && event.target.getAttribute('role')?.value !== 'option' && authProvider) {
    // console.log('Before Renewal token', event.type === 'mousemove' && reload && authProvider, event.type, reload);
    if (event.type === 'mousemove' && reload && authProvider) {
      callGetAfterCount++;
      // console.log('Renewal token', event?.target?.className);

      //
      if (callGetAfterCount > 5) {
        authProvider.acquireTokenSilent(authenticationSilentParameters).then((token) => {
          if (
            token.idToken.rawIdToken !==
            localStorage.getItem(API_HEADERS.authToken)
          ) {
            localStorage.setItem(
              API_HEADERS.authToken,
              token.idToken.rawIdToken
            );
            const fetchedDate = getLastFetchedSPSTokenData();
            if (fetchedDate === null || diffInMinutes(fetchedDate) > 5) {
              apiRequestNoLoadder({ url: API_URL.Users.AcquireSPToken }).then(({ updateData }) => {
                if (updateData) {
                  setSPSToken(updateData);
                }
              });
            }

            function diffInMinutes (dt1) {
              let diff = ((new Date()).getTime() - dt1.getTime()) / 1000;
              diff /= 60;
              return (Math.round(diff));
            }
          }
        });

        callGetAfterCount = 0;
      }
    }
  }

  function onIdle () {
    //console.log('Idle - relogin in process')    
    ShowToast("Your session has expired due to inactivity. Please refresh the page to continue.", toastType.WARNING, false, 500);
  }

  return (
    <IdleTimer
      element={document}
      onIdle={onIdle}
      onAction={() => { }}
      debounce={250}
      timeout={IDLE_TIME} // After 45 minutes it will show idle message
    />
  );
}
